<template>
  <v-container class="pt-4">
    <div class="text-center mb-6">
      <h1 class="mb-0"><span>🕒</span>{{ $t('rollOffWizard.pickupType.title') }}</h1>
      <p class="mb-0">{{ $t('rollOffWizard.pickupType.subtitle') }}</p>
    </div>
    <v-row class="mb-8" align="center" justify="center">
      <v-col
        v-for="option in options"
        :key="option.value"
        cols="12"
        md="8"
        class="d-flex justify-center"
      >
        <v-card
          outlined
          flat
          class="pickup-card d-flex align-center pa-6 pa-md-2 border-2-point-5"
          :class="selected === option.value ? 'border-primary' : 'border'"
          :style="selected === option.value ? 'border-color : #0b6f52' : ''"
          @click="select(option.value)"
        >
          <v-img :src="option.img" class="no-drag mx-6" style="width:130px;height:130px;" :alt="$t(option.title)" />
          <div class="flex-grow-1">
            <div class="font-weight-bold mb-2" style="font-size:1.15rem;">{{ $t(option.title) }}</div>
            <div class="mb-0" style="color:#444;">{{ $t(option.desc) }}</div>
          </div>
          <div class="d-flex align-center justify-center px-4 pt-2 pt-md-0" style="height:100%;">
            <v-icon v-if="selected === option.value" color="success" style="font-size:1.5rem;">mdi-radiobox-marked</v-icon>
            <v-icon v-else color="#bdbdbd" style="font-size:1.5rem;">mdi-radiobox-blank</v-icon>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, inject } from 'vue'
import { useRollOffWizardStore } from '@/store/rollOffWizard'

const wizardStore = useRollOffWizardStore()

const selected = ref(wizardStore.pickupType)
const onContinue = inject('onContinue')

const options = [
  { value: 'single', title: 'rollOffWizard.pickupType.single.title', desc: 'rollOffWizard.pickupType.single.desc', img: 'https://embed.wasteconnections.com/images-widget/roll-off-wizard/Step3/single-time-pickup.png' },
  { value: 'multi', title: 'rollOffWizard.pickupType.multi.title', desc: 'rollOffWizard.pickupType.multi.desc', img: 'https://embed.wasteconnections.com/images-widget/roll-off-wizard/Step3/multi-time-pickup.png' }
]

function select(val) {
  if(!wizardStore.loading){
    wizardStore.loading = true
    selected.value = val
    wizardStore.setPickupType(val)
    if (onContinue) {
      setTimeout(() => {
        wizardStore.loading = false
        onContinue()
      }, 350)
    }
  }
}
</script>

<style scoped>
.pickup-card {
  cursor: pointer;
  min-height: 140px;
  border-radius: 16px;
  position: relative;
  transition: border 0.2s, box-shadow 0.2s;
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  transition: ease 0.5s;
}
.pickup-card:hover {
  border-color: #003F6F;
}
@media (max-width: 900px) {
  .pickup-card {
    width: 95vw !important;
    min-width: 0;
    max-width: 400px;
    flex-direction: column !important;
    align-items: flex-start !important;
    padding: 24px 16px !important;
  }
  .pickup-card img {
    margin-right: 0 !important;
    margin-bottom: 16px !important;
  }
}
.no-drag{
  user-select: none; 
  user-drag: none;
  -webkit-user-drag: none;
  pointer-events: none;
}
</style>